import { toBig } from '@talos/kyoko';

export function getTransferHomeCurrencyEstimate({ amount, rate }: { amount?: string; rate?: string }): string | null {
  const amountBig = toBig(amount);
  const rateBig = toBig(rate);

  if (amountBig == null || rateBig == null || amountBig.lte(0) || rateBig.lte(0)) {
    return null;
  }

  return amountBig.times(rateBig).toFixed();
}
